
import { Vue, Options, Prop, Watch } from "vue-property-decorator";
import CardTransferModel from "@/views/models/Transfer/CardTransferModel";
import { useRoute, useRouter } from "vue-router";
import * as Routes from "@/router/routerNames";
@Options({
	name: "card-transfer-confrim",
})
export default class CardTransferConfirm extends Vue {
	@Prop({ default: false }) visible: boolean;
	@Prop({ default: null }) formData: FormData;

	pinCode: string = "";

	ErrMessage: string = "";
	IsSuccess: boolean = false;
	IsLoad: boolean = false;
	router = useRouter();
	model: CardTransferModel = null;

	created() {
		this.model = new CardTransferModel();
	}

	@Watch("formData", { deep: true })
	onChangeFormData() {
		if (!this.formData) return;
		this.model = new CardTransferModel({
			ToName: this.formData.get("ToName").toString(),
			ToIban: this.formData.get("ToIban").toString(),
			Amount: this.formData.get("Amount").toString(),
			Commission: this.formData.get("Commission").toString(),
			Description: this.formData.get("Description").toString(),
		});
	}

	Transfer() {
		if (this.IsLoad) return false;
		this.ErrMessage = "";
		if (this.pinCode.length < 6) {
			this.ErrMessage = this.translation("EnterPINСode");
			return false;
		}

		var request = new FormData();
		let entries = this.formData.entries();
		this.formData.forEach((item) => {
			let ent = entries.next().value;
			request.append(`Transfer[${ent[0]}]`, ent[1]);
		});
		request.append("Pin", this.pinCode);

		this.IsLoad = true;
		// this.$api.Main.CardPayoutService.Transfer((res) => {
		//   this.IsLoad = false;

		//   if ((res as any).IsError) {
		//     this.$store.state.modalDialogAlert("Неизвестная ошибка при загрузке");
		//     return;
		//   }

		//   if (res.IsSuccess) this.IsSuccess = res.IsSuccess;
		//   else
		//     this.ErrMessage = this.$localization.translateResponseCode(
		//       res.ResponseCode
		//     );
		// }, request);//TODO api
	}

	onInputPin(pin: string) {
		this.pinCode = pin;
	}
	close() {
		this.ErrMessage = "";
		if (this.IsSuccess) this.router.push({ name: Routes.TRANSUCTIONS });
		this.$emit("close");
	}

	translation(key: string) {
		return this.$localization.getTranslate(key);
	}
}
